export default __webpack_public_path__ + "89923b64be7a02667d90988eb19473d2.png";